import api from './api';

const authService = {
  login: async (identifier: string, password: string) => {
    const response = await api.post('/api/auth/local', {
      identifier,
      password,
    });
    return response.data;
  },

  getCurrentUser: async () => {
    const response = await api.get('/api/users/me?populate=*');
    return response.data;
  },
};

export default authService; 